import React from 'react';
import { Box, Icon, Typography, IconId } from '@drone-js/core';
import { KeyInfoType } from 'component/page/deprecatedDetail/DetailCard/KeyInfos/KeyInfo.selectors';

type KeyItemDisplayValueType = { iconId: IconId } & Pick<React.ComponentProps<typeof Icon>, 'color'> & Required<Pick<React.ComponentProps<typeof Typography>, 'variant'>>;

const KeyItemDisplayProps: Record<KeyInfoType, KeyItemDisplayValueType> = {
    duration: { iconId: 'line.symbol.time', variant: 'body-s' },
    cancellation: { iconId: 'line.symbol.circle-minus', variant: 'body-s' },
    freeCancellation: { iconId: 'line.symbol.calendar-check', variant: 'body-s-strong', color: 'feedback.positive' },
    pickUp: { iconId: 'line.transportation.car', variant: 'body-s' },
    mobileTicket: { iconId: 'line.electrics.cellphone', variant: 'body-s' },
    printTicket: { iconId: 'line.electrics.printer', variant: 'body-s' },
    instantConfirmation: { iconId: 'line.symbol.lightning1', variant: 'body-s' },
};

export const KeyItem: React.FC<{ type: KeyInfoType; text: string }> = (props) => {
    if (!props.type || !props.text) {
        return null;
    }

    const displayProps = KeyItemDisplayProps[props.type];

    return (
        <Box data-testid={`activities-details-${props.type}`} mb="12" display="flex">
            <Icon size="16" id={displayProps.iconId} color={displayProps.color} label={props.text} />
            <Typography variant={displayProps.variant} textColor={displayProps.color} mx="8" tag="span">
                {props.text}
            </Typography>
        </Box>
    );
};
KeyItem.displayName = 'KeyItem';
